/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * CustomerProfileTimeWindowDtoBase
 * auto generated base class for the model CustomerProfileTimeWindowDtoModel.
 */
export const CustomerProfileTimeWindowDtoModelBase = ModelBase
  .named('CustomerProfileTimeWindowDto')
  .props({
    __typename: types.optional(types.literal("CustomerProfileTimeWindowDto"), "CustomerProfileTimeWindowDto"),
    /** Start time in military format (HH:mm) */
    startTime: types.union(types.undefined, types.null, types.string),
    /** End time in military format (HH:mm) */
    endTime: types.union(types.undefined, types.null, types.string),
    /** Start time in seconds since midnight (deprecated) */
    start: types.union(types.undefined, types.null, types.integer),
    /** End time in seconds since midnight (deprecated) */
    end: types.union(types.undefined, types.null, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class CustomerProfileTimeWindowDtoModelSelector extends QueryBuilder {
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
  get start() { return this.__attr(`start`) }
  get end() { return this.__attr(`end`) }
}
export function selectFromCustomerProfileTimeWindowDto() {
  return new CustomerProfileTimeWindowDtoModelSelector()
}

export const customerProfileTimeWindowDtoModelPrimitives = selectFromCustomerProfileTimeWindowDto().startTime.endTime.start.end
